import React from "react";

const SlipsFilterPanel = ({
    date_after, setDate_after,
    date_before, setDate_before,
    status, setstatus,
    setPage,
    onClose,
}) => {
    return (
        <section className='pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax]'>
            <div className="bg-white shadow-1 pb-[2vmax] px-[2vmax] rounded-[1vmax] mt-[2vmax]">
                <div className="border-b-[0.15vmax] pt-[1.5vmax] pb-[1vmax] font-bold flex justify-between">
                    <h3>Filters</h3>
                    <button onClick={onClose}>
                        <i className="fa-solid fa-xmark text-[1.5vmax]"></i>
                    </button>
                </div>
                <div className="flex justify-between flex-wrap">

                    {/* From date */}
                    <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center outline-blue-400 rounded-[2vmax] ${date_after ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                        <div className='w-[25%] bg-[image:var(--gradient)] rounded-l-[2vmax] font-bold text-white py-[0.75vmax] pl-[1vmax]'>From :</div>
                        <div className={`relative ${date_after ? 'w-[61%]' : 'w-[80%]'}`}>
                            <input
                                type='date'
                                value={date_after}
                                onChange={(e) => setDate_after(e.target.value)}
                                className='px-[2vmax] py-[0.7vmax] w-full pr-[2vmax] outline-none rounded-[2vmax] bg-transparent'
                            />
                        </div>
                        {date_after && (
                            <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]" onClick={() => setDate_after('')}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        )}
                    </div>

                    {/* To date */}
                    <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center outline-blue-400 rounded-[2vmax] ${date_before ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                        <div className='w-[20%] bg-[image:var(--gradient)] rounded-l-[2vmax] font-bold text-white py-[0.75vmax] pl-[1vmax]'>To :</div>
                        <div className={`relative ${date_before ? 'w-[66%]' : 'w-[75%]'}`}>
                            <input
                                type='date'
                                value={date_before}
                                onChange={(e) => setDate_before(e.target.value)}
                                className='px-[2vmax] py-[0.7vmax] w-full outline-none rounded-[2vmax] bg-transparent'
                            />
                        </div>
                        {date_before && (
                            <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]" onClick={() => setDate_before('')}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        )}
                    </div>

                    {/* Status */}
                    <div className={`flex my-[1vmax] w-full lg:w-[31.5%] border-[0.15vmax] h-fit items-center outline-blue-400 rounded-[2vmax] ${status ? 'border-[var(--color-2)] bg-blue-50' : ''}`}>
                        <div className={`relative ${status ? 'w-[86%]' : 'w-[100%] pr-[1vmax]'}`}>
                            <select
                                value={status}
                                onChange={(e) => { setPage(1); setstatus(e.target.value); }}
                                className='px-[2vmax] py-[0.7vmax] w-full pr-[4vmax] outline-none rounded-[2vmax] bg-transparent'
                            >
                                <option value="">Filter by Status</option>
                                <option value="1">Exported</option>
                                <option value="0">Not-Exported</option>
                            </select>
                        </div>
                        {status && (
                            <button className="w-[14%] h-fit text-[1.5vmax] text-gray-700 border-l-[0.2vmax]" onClick={() => setstatus('')}>
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        )}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default SlipsFilterPanel;
